module.exports = __webpack_public_path__ + "media/unauthenticated/signup-accountant-30da6936.png";